import { Badge } from '@/components/ui/badge'

export const OPEN_TO_WORK_BADGE_LABEL = 'Open to work'

export function OpenToWorkBadge({ className }: { className?: string }) {
  return (
    <Badge variant="successSoft" className={className}>
      {OPEN_TO_WORK_BADGE_LABEL}
    </Badge>
  )
}

export function openToWorkTitleBadge(openToWork?: boolean | null) {
  if (!openToWork) return null
  return { label: OPEN_TO_WORK_BADGE_LABEL, variant: 'successSoft' as const }
}
